import { JSONDateFormat } from '@/types/date';

export const dateToStringDefaultFormat = (date: Date, seconds?: boolean) =>
  date.toLocaleTimeString('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    ...(seconds && { second: '2-digit' })
  });

export const dateToTime = (date: Date, seconds?: boolean) =>
  date.toLocaleTimeString('sv-SE', {
    hour: '2-digit',
    minute: '2-digit',
    ...(seconds && { second: '2-digit' })
  });

export const dateSort = (date1: Date, date2: Date) => {
  return date1.getTime() - date2.getTime();
};

export const toJSONDate = (date: Date, shorten?: boolean): JSONDateFormat => {
  if (!shorten) return <JSONDateFormat>date.toISOString();
  const formattedDate = date.toISOString();
  console.debug('toJSONDate', formattedDate);
  return <JSONDateFormat>formattedDate;
};

export const parseJSONDate = (jsonDate: JSONDateFormat): Date => {
  return new Date(jsonDate);
};

export const isAfter = (date1: Date, date2: Date) => {
  return date1 > date2;
};

export const dateIsValid = (date: Date): boolean => {
  return date instanceof Date && !isNaN(date.getTime());
};

export const prettifyJSONDate = (jsonDate: JSONDateFormat): string => {
  const date = parseJSONDate(jsonDate);
  return dateToStringDefaultFormat(date);
};

/**
 * Parses a nullable string. If string is null or an invalid date it returns today's date.
 */
export const stringToDate = (dateString: string): Date => {
  const parsedDate = new Date(dateString);
  return dateIsValid(parsedDate) ? parsedDate : new Date();
};

export const isSameDay = (first: Date, second: Date) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate();

export const newDate = (hours: number, minutes: number) => {
  const currentDate = new Date();
  return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
};
